<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label for="color">{{ $t('cor') }}</label>
        <b-form-select class="input-pentagro" v-model="color" name="color" id="color">
          <b-form-select-option 
            v-for="(c, i) in colorKeys" 
            :key="c"
            :value="colors[c]"
          >
            {{(i+1)+"-"+c}}
          </b-form-select-option>
        </b-form-select>

        <div  class="flex">
          <label>{{ $t('espessura-da-seta-px-0') }}</label>
          <b-input 
            class="input-pentagro"
            type="number" 
            v-model="node.stroke"
            min="0.00"
          ></b-input>
        </div>
        <span v-if="node.type == types.Line">
          <div class="mt-2 arrow-set">
            <label>{{ $t('alinhamento') }}</label>
            <b-button-group class="ml-3">
              <b-button :class="{ 'btn-success': align == 'horizontal' }" @click="setAlign" title="$t('alinhar-horizontalmente')" value="horizontal">
                <b-icon class="icon" value="horizontal" icon="align-center"></b-icon>
              </b-button>
              <b-button :class="{ 'btn-success': align == 'vertical' }" title="$t('alinhar-verticalmente')" @click="setAlign" value="vertical">
                <b-icon class="icon" value="vertical" icon="align-middle"></b-icon>
              </b-button>
            </b-button-group>
          </div>
          <b-form-checkbox
            class="ml-2"
            v-model="node.dasharray"
          >
            {{ $t('linha-tracejada') }}
          </b-form-checkbox>
        </span>
      </div>

    </b-form>
  </div>
</template>

<script>
import { COLORS } from "../utils/colors"
import { Types } from "../utils/nodeTypes"

  export default {
    props: {
      node: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
       colorKeys: Object.keys(COLORS).sort(),
       colors: COLORS,
       types: new Types,
       size: parseFloat(this.node.size) / 50,
       rotate: this.node.rotate,
       color: this.node.color,
       align: null,
      }
    },

    watch:{
      color() { this.node.color = this.color }
    },

    methods: {
      setAlign(value){
        if(value.target.value){
          this.align = value.target.value
        }
        else if(value.srcElement.parentElement.value){
          this.align = value.srcElement.parentElement.value
        }
        this.node.setAlign(this.align)
      }
    },

    mounted(){ }
  }
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}
</style>